/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Radio,
  RadioGroup
} from '@chakra-ui/core';

/**
 * Dependênicas internas
 */
import getInformacoesDoCampo from '../../../../../utils/form/getInformacoesDoCampo';

const Receita = props => {
  const nomeDoCampo = 'receita';

  const { formik, ...rest } = props;

  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl isInvalid={possuiErroDeValidacao} {...rest}>
      <FormLabel htmlFor={nomeDoCampo}>Receita</FormLabel>
      <RadioGroup
        isInline
        spacing={4}
        value={valor}
        onChange={handleChange}
        onBlur={handleBlur}
        name={nomeDoCampo}
      >
        <Radio value="ADMINISTRACAO" size="md" isDisabled={rest.isDisabled}>
          Administração
        </Radio>
        <Radio value="CONDOMINO" isDisabled={rest.isDisabled}>
          Condomino
        </Radio>
      </RadioGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Receita);
